module.exports = __webpack_public_path__ + "static/media/calendar.60e07bb8.svg";